import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import EstimateForm from "@/components/forms/EstimateForm";
import { BUSINESS } from "@/lib/site";

export default function Hero() {
  return (
    <section data-testid="hero-section" className="relative overflow-hidden pt-24 md:pt-32 pb-16 md:pb-24">
      <div className="container-page grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center">
        <div className="lg:col-span-7">
          <p className="overline mb-5" data-testid="hero-overline">Construction · Plumbing · HVAC · ADU · Los Angeles</p>
          <h1 data-testid="hero-headline" className="heading-1">
            Build with <span className="italic font-extrabold text-brand-olive-hover">confidence.</span><br/>
            From ADUs to repairs — done clean, done right.
          </h1>
          <p className="body-base mt-6 max-w-xl" data-testid="hero-sub">
            From complete ADU construction to plumbing repairs and HVAC installations, ME Builders delivers reliable craftsmanship, clean work, and professional service you can trust across {BUSINESS.region}.
          </p>
          <div className="mt-8 flex flex-wrap items-center gap-3">
            <a href="#estimate" data-testid="hero-estimate-cta" className="btn-primary">
              Get Free Estimate <ArrowRight className="w-4 h-4" />
            </a>
            <Link to="/services" data-testid="hero-services-cta" className="btn-secondary">
              Explore Services
            </Link>
            <a href={BUSINESS.phoneHref} data-testid="hero-call-cta" className="btn-ghost">
              or call {BUSINESS.phone}
            </a>
          </div>
          <div className="mt-10 flex flex-wrap gap-x-6 gap-y-3 text-xs">
            <span className="badge-trust">Licensed & Insured</span>
            <span className="badge-trust">Free Estimates</span>
            <span className="badge-trust">Clean Workmanship</span>
            <span className="badge-trust">Same-Week Scheduling</span>
          </div>
        </div>

        <div className="lg:col-span-5 relative">
          <div className="aspect-[4/5] w-full rounded-md overflow-hidden border border-brand-line">
            <img
              src="https://images.pexels.com/photos/36241380/pexels-photo-36241380.jpeg"
              alt="Modern home exterior in Los Angeles at sunset"
              className="w-full h-full object-cover"
              loading="eager"
            />
          </div>
          <div className="hidden md:block absolute -bottom-6 -left-6 w-56 bg-white border border-brand-line rounded-md p-5 shadow-[0_8px_30px_rgba(0,0,0,0.06)]">
            <p className="overline mb-1">Today</p>
            <p className="font-heading text-xl font-bold tracking-tight text-brand-ink">Same-week site visit</p>
            <p className="text-xs text-brand-ash mt-1">Schedule a free callback in under 60 seconds.</p>
          </div>
        </div>
      </div>

      {/* Subtle background ornament */}
      <div aria-hidden className="pointer-events-none absolute -top-32 right-0 w-[480px] h-[480px] rounded-full bg-brand-limestone blur-3xl opacity-50" />
    </section>
  );
}
